<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Debounce-Timer und Anfrage-Generation je Komponenteninstanz (nicht modulweit).
    this._timer = null;
    this._reqId = 0;

    GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder
    });
  },

  beforeDestroy() {
    this._abort();
  },

  watch: {
    search(val) {
      if (val && val !== this.select) {
        this.querySelections(val);
      } else if (!val) {
        // Leere Eingabe: Timer und laufende Anfrage beenden, Treffer verwerfen.
        this._abort();
        this.items = [];
        this.loading = false;
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    _abort() {
      if (this._timer != null) {
        clearTimeout(this._timer);
        this._timer = null;
      }
      // Ungültigt jede noch ausstehende Antwort.
      this._reqId++;
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
    },

    querySelections(value) {
      if (!this.geocoder) {
        return;
      }

      if (this._timer != null) {
        clearTimeout(this._timer);
      }
      this.geocoder.cancelAutocomplete();

      const reqId = ++this._reqId;
      this.loading = true;

      this._timer = setTimeout(() => {
        this.geocoder.autocomplete(value).then(items => {
          // Nur die jüngste Antwort darf Treffer verändern.
          if (reqId !== this._reqId) {
            return;
          }
          this.items = Array.isArray(items) ? items.slice() : [];
        }).finally(() => {
          // Nur die jüngste Antwort darf den Ladezustand zurücksetzen.
          if (reqId === this._reqId) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.$emit("change", o);
    }
  }
};
</script>
